import { NgModule, NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';

import { SpOverviewRoutingModule } from './sp-overview-routing.module';
import { SpOverviewComponent } from './sp-overview.component';
import { CoreModule } from 'src/app/core/core.module';
import { PipeBold } from 'src/app/shared/pipes/pipeBold.pipe';
import { FormsModule } from '@angular/forms';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from 'src/app/shared/shared.module';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    CoreModule,
    SpOverviewRoutingModule,
    NgbModule,
    SharedModule
  ],
  declarations: [
    SpOverviewComponent,
    PipeBold
  ],
  providers:[DatePipe],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA ]
})
export class SpOverviewModule { }
